import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { COUNTRIES } from '../../constants/countries.js';
import { block } from '../../utils/block.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { DropdownList } from '../Dropdown/DropdownList.js';
import { DropdownItem } from '../Dropdown/DropdownItem.js';

const _excluded = ["alpha2Codes", "selectedAlpha2Code", "onCheck", "isOpen", "className", "id"];
const b = block('phone-input');
const PhoneInputList = _ref => {
  let {
      alpha2Codes,
      selectedAlpha2Code,
      onCheck,
      isOpen,
      className = '',
      id
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(DropdownList, _objectSpread2(_objectSpread2({
    isOpen: isOpen,
    className: b('list').mix(className)
  }, rest), {}, {
    children: alpha2Codes.map(code => /*#__PURE__*/jsxs(DropdownItem, {
      onClick: onCheck(code),
      icon: /*#__PURE__*/jsx("span", {
        className: b('list-icon').mix("fi fi-".concat(String(code).toLowerCase()))
      }),
      isChecked: selectedAlpha2Code === code,
      id: "".concat(id, "-").concat(code),
      className: b('list-item', {
        checked: selectedAlpha2Code === code
      }),
      children: [COUNTRIES[code].name, " ", /*#__PURE__*/jsxs("span", {
        className: b('phone-code'),
        children: ["(+", COUNTRIES[code].phoneCode, ")"]
      })]
    }, code))
  }));
};

export { PhoneInputList };
